import React, { useState } from 'react';
import { GiftCardInfoModal } from './GiftCardInfoModal/index';

import './giftCardInfo.css';

export const GiftCardInfo = ({ giftPlan }) => {
  const [showModal, toggleModal] = useState(false);
  const onClick = () => toggleModal(true);
  const giftData = giftPlan;

  if (!giftData) {
    return null;
  }

  const {
    imgSrc: { default: defaultImgSrc, modal: modalImgSrc },
  } = giftData;

  return (
    <div className="giftCardInfo">
      <div className="giftCardInfoTitle">Congrats! Your gift includes:</div>
      {defaultImgSrc ? (
        <button type="button" className="giftCardImgWrapper" onClick={onClick}>
          <span className="giftCardImageButton">Open</span>
          <img className="giftCardImg" src={defaultImgSrc} alt="giftImg" />
        </button>
      ) : null}
      <div className="giftCardInfoData">
        <div className="giftCardTitle">{giftData.title}</div>
        <div className="giftCardDescription">{giftData.description}</div>
        <div className="giftCardDescription">{giftData.subDescription}</div>
        <div className="giftCardDescription">{giftData.subDescription2}</div>
      </div>
      {modalImgSrc ? (
        <GiftCardInfoModal isOpen={showModal} src={modalImgSrc} onClose={() => toggleModal(false)} />
      ) : null}
    </div>
  );
};
